"use client";

import * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";

import { cn } from "./utils";

function Avatar({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn(
        "relative flex size-10 shrink-0 overflow-hidden rounded-full",
        className,
      )}
      style={{
        borderRadius: '50%',
        overflow: 'hidden',
        ...props.style,
      }}
      {...props}
    />
  );
}

function AvatarImage({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn("aspect-square size-full object-cover", className)}
      style={{
        borderRadius: '50%',
        objectFit: 'cover',
        width: '100%',
        height: '100%',
        ...props.style,
      }}
      onError={(e) => {
        // Ensure error is caught (429 rate limits, network errors, etc.)
        // Radix Avatar will automatically show fallback when image fails
        console.warn('Avatar image failed to load:', {
          src: props.src,
          error: e,
          isGoogleImage: props.src?.includes('googleusercontent.com'),
        });
        props.onError?.(e);
      }}
      {...props}
    />
  );
}

function AvatarFallback({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn(
        "bg-muted flex size-full items-center justify-center rounded-full",
        className,
      )}
      {...props}
    />
  );
}

export { Avatar, AvatarImage, AvatarFallback };
